import { useTheme } from '../theme/ThemeContext';
import { useState } from 'react';

export default function SubSampleStudies({ multipleSamplesMetaData }) {
    const { theme } = useTheme();
    const mapOfStudies = new Map();
    const [openStudies, setOpenStudies] = useState(new Set());

    multipleSamplesMetaData.forEach((sample) => {
        if (mapOfStudies.has(sample.mgnify_study_id)) {
            mapOfStudies.get(sample.mgnify_study_id).push(sample.run_assembly_id);
        } else {
            mapOfStudies.set(sample.mgnify_study_id, [sample.run_assembly_id]);
        }
    });

    const sortedMapOfStudies = new Map(
        [...mapOfStudies.entries()].sort((a, b) => b[1].length - a[1].length)
    );

    const toggleStudy = (studyId) => {
        const newOpenStudies = new Set(openStudies);
        if (newOpenStudies.has(studyId)) {
            newOpenStudies.delete(studyId);
        } else {
            newOpenStudies.add(studyId);
        }
        setOpenStudies(newOpenStudies);
    };

    const sampleCountText = (mapOfStudies.size === 1)
        ? `Samples from ${mapOfStudies.size} study are selected`
        : `Samples from ${mapOfStudies.size} studies are selected`;

    return (
        <div>
            <p>{sampleCountText}</p>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                {[...sortedMapOfStudies].map(([studyId, runIds]) => (
                    <li style={{ color: theme.colors.text }} key={studyId}>
                        <div
                            onClick={() => toggleStudy(studyId)}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
                        >
                            <span style={{ fontSize: "10px" }}>{openStudies.has(studyId) ? '▼' : '▶'}</span>
                            <a
                                href={`https://www.ebi.ac.uk/metagenomics/studies/${studyId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: theme.colors.text }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {studyId}
                            </a>
                            <span>({runIds.length} samples)</span>
                        </div>
                        {openStudies.has(studyId) && (
                            <ul style={{
                                marginLeft: '20px',
                                fontSize: '12px',
                                display: 'flex',
                                flexWrap: 'wrap',
                                // gap: '8px',
                                columnGap: '8px',
                                listStyle: 'none',
                                padding: 0
                            }}>
                                {runIds.map((runId, index) => (
                                    <li
                                        key={runId}
                                        style={{
                                            color: theme.colors.text,
                                        }}
                                    >
                                        {runId}{index < runIds.length - 1 ? ',' : ''}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}